import { useEffect, useState } from 'react';

import STORE from 'store';

// Listens to a single maintenanceModes doc. Fails open: a read error (e.g. the
// rules not being deployed yet) is treated as "no maintenance" so a mistake
// here can never lock every customer out of the app.
const useMaintenanceModeDoc = (docId: string) => {
  const [settings, setSettings] = useState<
    MaintenanceMode.Settings | undefined
  >();
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    let isActive = true;
    setIsLoading(true);

    const unsubscribe = STORE.getMaintenanceModesRef()
      .doc(docId)
      .onSnapshot(
        (snapshot) => {
          if (!isActive) {
            return;
          }
          setSettings(snapshot.data());
          setIsLoading(false);
        },
        (error) => {
          if (!isActive) {
            return;
          }
          console.log(`Failed to read maintenance mode for ${docId}`, error);
          setSettings(undefined);
          setIsLoading(false);
        },
      );

    return () => {
      isActive = false;
      unsubscribe();
    };
  }, [docId]);

  return { settings, isLoading };
};

export default useMaintenanceModeDoc;
